var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import Tile from './Tile';
const defaultProps = {
    large: false,
    video: {
        pause: true,
        autoplay: true,
        muted: true,
        loop: true,
    },
};
const VideoTile = (_a) => {
    var { video, onChangeMute } = _a, attributes = __rest(_a, ["video", "onChangeMute"]);
    const videoProps = Object.assign({}, defaultProps.video, video);
    const { muted, pause } = videoProps;
    const videoRef = React.useRef(null);
    const [mutedState, setMutedState] = useState(muted);
    const [pauseState, setPause] = useState(pause);
    const { isMobile } = attributes;
    const isControlled = typeof onChangeMute === 'function';
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.pause();
            setPause(true);
        }
    }, [isMobile]);
    useEffect(() => {
        if (!isControlled) {
            setMutedState(muted);
        }
    }, [muted]);
    const handleChangeMute = (newState) => {
        if (isControlled) {
            onChangeMute(newState);
        }
        else {
            setMutedState(newState);
        }
    };
    const handleVideoAction = (action) => {
        if (!videoRef.current) {
            return;
        }
        if (action === 'play') {
            videoRef.current.play();
            setPause(false);
        }
        else if (action === 'pause') {
            videoRef.current.pause();
            setPause(true);
        }
        else if (action === 'mute') {
            handleChangeMute(true);
        }
        else if (action === 'unmute') {
            handleChangeMute(false);
        }
    };
    return (<Tile {...attributes} videoRef={videoRef} video={Object.assign(Object.assign({}, videoProps), { pause: pauseState, muted: isControlled ? muted : mutedState })} onVideoAction={handleVideoAction}/>);
};
VideoTile.defaultProps = defaultProps;
export default VideoTile;
